module.exports = __webpack_public_path__ + "media/images/pokerroom/888/logo-a38b6eae42f520ab7ccf593aa7e8b0c7.png";